import React from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import css from "./SaveFilterComponent.module.css";
import { Button } from "../Button/Button";
import { TrashIconGray } from "../../constant/imagePath";
import { Col, Row } from "react-bootstrap";

export const SaveFilterComponent = ({ title, startDate, endDate, onClick }) => {
  return (
    <>
      <div
        style={{
          borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
        }}
        className={[css.saveFilterRow].join(" ")}
      >
        <div>
          <p
            style={{
              ...Fonts.b1Mobile,
              color: Colors.neutralShadesOfNero,
              paddingBottom: "8px",
              whiteSpace: "pre",
            }}
          >
            {title.map(
              (item, index) => item + `${title.length > 1 ? "    .    " : " "}`
            )}
          </p>
          <p
            style={{
              ...Fonts.h9,
              color: Colors.neutralShadesOfDimGray,
            }}
          >
            {startDate}
            {endDate && " - " + endDate}
          </p>
        </div>
        <div>
          <Button
            icon={TrashIconGray}
            customStyle={{
              border: "unset",
            }}
            onClick={onClick}
            textColor={Colors.neutralShadesOfNero}
          />
        </div>
      </div>
    </>
  );
};
